module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('GroupBase', [_c('p', {
    staticClass: "fs-6 mb-3 text-muted text-center"
  }, [_vm._v("Create a new group and organize with others.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createGroup($event)
      }
    }
  }, [_c('HorizontalInputField', {
    attrs: {
      "label": 'Group Name',
      "value": _vm.groupName,
      "placeholder": 'Untitled Group',
      "required": true
    },
    on: {
      "update:value": function($event) {
        _vm.groupName = $event
      }
    }
  }), _vm._v(" "), _c('HorizontalSelectField', {
    attrs: {
      "label": 'Privacy Setting',
      "options": _vm.options,
      "selected": _vm.privacySetting,
      "required": true
    },
    on: {
      "update:selected": function($event) {
        _vm.privacySetting = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: _vm.loading && 'is-loading',
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Create\n            ")])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-32069b89"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupCreate.vue
// module id = 1003
// module chunks = 0